import { render, staticRenderFns } from "./LightOverlay.vue?vue&type=template&id=f55af1b8&scoped=true&"
import script from "./LightOverlay.vue?vue&type=script&lang=js&"
export * from "./LightOverlay.vue?vue&type=script&lang=js&"
import style0 from "./LightOverlay.vue?vue&type=style&index=0&id=f55af1b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55af1b8",
  null
  
)

export default component.exports